import EventOne from "../../../Assets/Images/upcoming-events-1.png";
import EventTWO from "../../../Assets/Images/upcoming-events-2.png";
import EventThree from "../../../Assets/Images/upcoming-events-3.png";
// import EventFour from "../../../Assets/Images/events-four.png";
import "./upcomingevents.css";

const UpcomingEvents = () => {
  return (
    <div className="ue-container mr-b">
      <h2 className="black-text-clip text-center">Upcoming Events</h2>
      <div className="ue-listing">
        <div
          onClick={() => {
            window.location.href = "https://summercamp.bwcsports.com/";
          }}
          className="ue-card-item"
        >
          <img src={EventThree} alt="EventsImage" />
          {/* <button>Coming Soon</button> */}
        </div>

        {/* <div className="ue-card-item">
          <img src={EventFour} alt="EventsImage" />
          <button>Coming Soon</button>
        </div> */}
      </div>
    </div>
  );
};
export default UpcomingEvents;
